const getPrevStep = (activeIndex, steps) => {
  const allStepsCount = steps.length;

  if (activeIndex > allStepsCount - 1) return [false, 0];

  const isPrevStep = activeIndex - 1 >= 0;
  const prevStep = isPrevStep ? activeIndex - 1 : 0;

  return [isPrevStep, prevStep];
};

export default getPrevStep;
